// pages/HomePage.js
import React from 'react';
import Contact from '../components/ContactPage/Contact';
import Footer from '../components/Footer';


function ContactPage() {
  return (
    <div>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default ContactPage;
